import { v4 } from 'uuid'

const Box = ({ lines, x, y, width, height, className, paddingTop, ...props }) => {
	const centerx = parseFloat(x) + (width / 2)

	if (paddingTop === undefined) {
		paddingTop = false
	}

	return (
		<>
			<rect {...props} className={className + " box"} rx="10" x={x} y={y} width={width} height={height} />
			<text className="box" textAnchor="middle" x={centerx} y={y + (paddingTop * 10)}>
				{lines.map((line) => <tspan key={v4()} x={centerx} dy="20">{line}</tspan>)}
				{props.children}
			</text>
		</>
	)
}

export default Box
